// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3Jdyp","left":"StickyBox_left__1TKBZ","right":"StickyBox_right__3msT5"};